module.exports = __webpack_public_path__ + "static/media/icManual.9dff0d1d.svg";